"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxSize = void 0;
var _ = __importStar(require("lodash"));
var EventRegistry_1 = __importDefault(require("./EventRegistry"));
var InMemoryCollection_1 = __importDefault(require("./InMemoryCollection"));
exports.maxSize = 100;
/*
  ChannelMessageStorage handle storing messages. It should cover below cases
  -  Receiving a new message via socket
  -  Loading previous message
  -  Loading missed message in case of diconnecting and reconnecting.

  Known issues:
  - Currently it is using createdAt date as marker to load previous/later messages.
    However it is not 100% reliable in case multiple messages had the exact same time.
  - Throwing error and retrying in case of error
*/
var ChannelMessageStorage = /** @class */ (function () {
    function ChannelMessageStorage(channelId) {
        this.channelId = channelId;
        this.messagesCollection = new InMemoryCollection_1.default('id');
        this.eventRegistry = new EventRegistry_1.default();
        this.notMergedMessages = [];
        this.liveUpdate = false;
        this.hasMoreEarlier = false;
        this.loadingEarlier = false;
        this.loadingLater = false;
        this.initialMessagesLoaded = false;
    }
    ChannelMessageStorage.prototype.setLiveUpdate = function (liveUpdate) {
        this.liveUpdate = liveUpdate;
    };
    ChannelMessageStorage.prototype.upsert = function (messages) {
        var len = messages.length;
        for (var i = 0; i < len; i++) {
            if (messages[i].localId) {
                // make sure queued messsage is removed
                this.messagesCollection.remove(messages[i].localId);
            }
            this.messagesCollection.upsert(messages[i]);
        }
    };
    ChannelMessageStorage.prototype.addLiveMessage = function (newMessages) {
        if (this.liveUpdate) {
            this.upsert(newMessages);
            this.eventRegistry.emit('update', {});
        }
        else {
            var messages = _.concat(this.notMergedMessages, newMessages);
            this.notMergedMessages = messages;
        }
    };
    ChannelMessageStorage.prototype.removeMessage = function (id) {
        this.messagesCollection.remove(id);
        this.eventRegistry.emit('update', {});
    };
    ChannelMessageStorage.prototype.softDeleteMessage = function (id) {
        var message = this.messagesCollection.find(id);
        this.messagesCollection.upsert(__assign(__assign({}, message), { isDeleted: true, content: 'This message was deleted' }));
        this.eventRegistry.emit('update', {});
    };
    ChannelMessageStorage.prototype.markAllQueuedMessagesAsRetriable = function () {
        var messages = this.sortedMessages();
        for (var i = 0; i < messages.length; i++) {
            if (messages[i].isQueued) {
                messages[i] = __assign(__assign({}, messages[i]), { isRetriable: true });
                // mark message as failed
                this.messagesCollection.upsert(messages[i]);
            }
        }
        if (this.liveUpdate) {
            this.eventRegistry.emit('update', {});
        }
    };
    ChannelMessageStorage.prototype.addLaterMessage = function (laterMessages) {
        this.upsert(laterMessages);
        if (exports.maxSize && laterMessages.length < exports.maxSize) {
            //TODO: remove duplicates from messagesCache
            this.upsert(this.notMergedMessages);
            this.notMergedMessages = [];
            this.liveUpdate = true;
        }
        else {
            this.liveUpdate = false;
        }
    };
    ChannelMessageStorage.prototype.addEarlierMessage = function (ealierMessages) {
        this.upsert(ealierMessages);
        if (exports.maxSize && ealierMessages.length < exports.maxSize) {
            this.hasMoreEarlier = false;
        }
        else {
            this.hasMoreEarlier = true;
        }
    };
    ChannelMessageStorage.prototype.sortedMessages = function () {
        return this.messagesCollection.sort('createdAt');
    };
    ChannelMessageStorage.prototype.latestDate = function () {
        var _a;
        var messages = this.messagesCollection.sort('updatedAt', 'desc');
        return (_a = messages[0]) === null || _a === void 0 ? void 0 : _a.updatedAt;
    };
    ChannelMessageStorage.prototype.earliestDate = function () {
        var _a;
        var messages = this.sortedMessages();
        return (_a = messages[0]) === null || _a === void 0 ? void 0 : _a.createdAt;
    };
    ChannelMessageStorage.prototype.state = function () {
        return {
            messages: this.sortedMessages(),
            liveUpdate: this.liveUpdate,
            hasMoreEarlier: this.hasMoreEarlier,
            loadingEarlier: this.loadingEarlier,
            loadingLater: this.loadingLater,
        };
    };
    ChannelMessageStorage.prototype.loadEarlier = function (chatClient, unreadMessageCount, lastReadMessageId) {
        return __awaiter(this, void 0, void 0, function () {
            var earlierMessages, limitAfter, limitBefore, messagesBeforeLastReadMessageId, _a, messagesAfterLastReadMessageId, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loadingEarlier = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 9, , 10]);
                        if (!unreadMessageCount || unreadMessageCount < exports.maxSize) {
                            this.liveUpdate = true;
                        }
                        else {
                            this.liveUpdate = false;
                        }
                        if (!unreadMessageCount) return [3 /*break*/, 6];
                        limitAfter = Math.min(unreadMessageCount + 1, exports.maxSize);
                        limitBefore = Math.max(exports.maxSize - limitAfter, 0);
                        if (!(limitBefore > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, chatClient.loadMessagesBeforeId(this.channelId, lastReadMessageId || 0, limitBefore)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = [];
                        _b.label = 4;
                    case 4:
                        messagesBeforeLastReadMessageId = _a;
                        return [4 /*yield*/, chatClient.loadMessagesAfterId(this.channelId, lastReadMessageId || 0, limitAfter)];
                    case 5:
                        messagesAfterLastReadMessageId = _b.sent();
                        earlierMessages = __spreadArray(__spreadArray([], messagesBeforeLastReadMessageId), messagesAfterLastReadMessageId);
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, chatClient.loadEarlierMessages(this.channelId, this.earliestDate(), exports.maxSize)];
                    case 7:
                        earlierMessages = _b.sent();
                        _b.label = 8;
                    case 8:
                        this.initialMessagesLoaded = true;
                        this.loadingEarlier = false;
                        this.addEarlierMessage(earlierMessages);
                        this.eventRegistry.emit('update', {});
                        return [3 /*break*/, 10];
                    case 9:
                        error_1 = _b.sent();
                        //Emit Error
                        console.log(error_1);
                        this.loadingEarlier = false;
                        this.eventRegistry.emit('update', {});
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    ChannelMessageStorage.prototype.loadLater = function (chatClient) {
        return __awaiter(this, void 0, void 0, function () {
            var laterMessages, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingLater = true;
                        this.eventRegistry.emit('update', {});
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, chatClient.loadLaterMessages(this.channelId, this.latestDate(), exports.maxSize)];
                    case 2:
                        laterMessages = _a.sent();
                        this.loadingLater = false;
                        this.addLaterMessage(laterMessages);
                        this.eventRegistry.emit('update', {});
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.loadingLater = false;
                        this.eventRegistry.emit('update', {});
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ChannelMessageStorage.prototype.loadAllLater = function (chatClient) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        _a.label = 1;
                    case 1: return [4 /*yield*/, this.loadLater(chatClient)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!this.liveUpdate) return [3 /*break*/, 1];
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_3 = _a.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ChannelMessageStorage.prototype.onUpdate = function (callback) {
        return this.eventRegistry.on('update', callback);
    };
    return ChannelMessageStorage;
}());
exports.default = ChannelMessageStorage;
//# sourceMappingURL=ChannelMessageStorage.js.map